
import { Link } from "react-router-dom";
import { LightbulbIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const NavbarLogo = () => {
  return (
    <div className="flex-shrink-0 mr-6">
      <Link to="/" className="text-primary font-semibold text-xl flex items-center gap-2 transition-transform hover:scale-[1.02]">
        <LightbulbIcon className="h-6 w-6" />
        <span>GetPrompts</span>
        <Badge 
          variant="success" 
          className="ml-1.5 text-xs font-semibold uppercase tracking-wide px-2 py-0.5"
        >
          Alpha
        </Badge>
      </Link>
    </div>
  );
};

export default NavbarLogo;
